import { z } from 'zod';
import { createService } from '../../api/createService';
import { Event } from '../../state/events/events.types';
import { EventsResponseSchema } from './NotificationsService.schemas';

export default createService(
  {
    getEvents: {
      method: 'GET',
      url: '/events',
      responseSchema: EventsResponseSchema,
    },
    updateEvent: {
      method: 'PATCH',
      url: ({ id }: { id: Event['id'] }) => `/events/${id}`,
      responseSchema: z.object({}),
    },
  },
  ({ userId }) => `/notifications/Players/${userId}`,
);
